import angular from 'angular';
import { Services } from '@Shared.Angular/@types/services';

export interface IImproveHtmlResponse {
  improvedHtml: string;
}

export interface IImproveHtmlRequest {
  contentHtml: string;
}

export class AiService {
  public static $inject = ['$http', 'APP_CONFIG'];

  private readonly AUTHENTICATED_API: string;

  constructor(
    private $http: angular.IHttpService,
    APP_CONFIG: Services.APP_CONFIG
  ) {
    this.AUTHENTICATED_API = `${APP_CONFIG.apiBaseUrl}ai`;
  }

  public improveHtml(contentHtml: string): angular.IPromise<string> {
    const request: IImproveHtmlRequest = {
      contentHtml
    };

    return this.$http
      .post<IImproveHtmlResponse>(
        `${this.AUTHENTICATED_API}/improvehtml`,
        request
      )
      .then((response: angular.IHttpResponse<IImproveHtmlResponse>) => {
        return response.data.improvedHtml;
      });
  }
}

angular.module('flowingly.services').service('aiService', AiService);

export type AiServiceType = InstanceType<typeof AiService>;
